module.exports = __webpack_public_path__ + "img/creation_business.4be4650e.svg";